<template>
  <footer class="footer-page">
    <div class="container-fluid">
      <div class="layout-table-sm">
        <div>
          <a :href="stateUrl + '/park/privacy'">Privacy Policy</a>
        </div>
        <div>
          <a :href="stateUrl + '/park/termsandconditions'"
            >Terms and Conditions</a
          >
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  computed: {
    stateUrl() {
      return process.env.VUE_APP_STATE_URL;
    }
  }
};
</script>
